export default "__VITE_ASSET__BbdEMOY7__"